import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import {
  CancellationThreshold,
  CancellationThresholdApiResponse,
} from 'models/Professional/CancellationThreshold.types'

export async function getCancellationThreshold(
  professionalUsername: string
): Promise<CancellationThreshold> {
  const response = await axios.get(
    apiEndpoints.METRICS_PROFESSIONAL_CANCELLATION_THRESHOLD(professionalUsername)
  ) as CancellationThresholdApiResponse

  const { monthly_threshold, cancellations, remaining } = response.data

  return {
    monthlyThreshold: monthly_threshold,
    cancellations,
    remaining,
  }
}
